import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AnimatedBackground from "../components/AnimatedBackground";
import { setPageMeta } from "../utils/seo";

import "./AIFirewall.css";

const AIFirewall = () => {
  useEffect(() => {
    setPageMeta(
      "SapienShield AI Firewall | Sapiencia.AI",
      "SapienShield protects LLMs and AI agents from prompt injection, data leakage, and adversarial threats."
    );
  }, []);

  return (
    <div className="ai-firewall-page">
      <AnimatedBackground />
      <Navbar />

      <div className="ai-firewall-content glass">

        {/* Logo */}
        <img
          src="/SapienShield.jpeg"
          className="sapien-logo"
          alt="SapienShield Logo"
          width="200"
          height="200"
        />

        {/* TITLE — one line */}
        <h1 className="sapien-title">
          SapienShield — The AI Firewall for Modern Applications
        </h1>

        {/* DESCRIPTION */}
        <p className="sapien-description">
          SapienShield is Sapiencia.AI’s purpose-built AI Firewall that protects
          LLM apps, AI agents, and AI-enabled APIs from emerging AI-specific threats.
          It inspects prompts and model responses in real time to stop attacks
          traditional security tools miss.
        </p>

        {/* Sections */}
        <h2 className="sapien-subtitle">What It Protects Against</h2>
        <ul className="sapien-list">
          <li>Prompt injection & jailbreaks</li>
          <li>Data leakage & model extraction</li>
          <li>Toxic or harmful outputs</li>
          <li>Adversarial inputs & malicious code</li>
          <li>AI-driven denial-of-service behavior</li>
        </ul>

        <h2 className="sapien-subtitle">How It Works</h2>
        <ul className="sapien-list">
          <li>Semantic threat detection that understands intent</li>
          <li>Bidirectional guardrails for prompts and responses</li>
          <li>Real-time risk scoring to modify, redact, block, or rate-limit</li>
          <li>Continuous analytics for audits & insights</li>
        </ul>

        <h2 className="sapien-subtitle">Why It’s Different</h2>
        <ul className="sapien-list">
          <li>Built natively for AI (not adapted from legacy WAFs)</li>
          <li>Model-agnostic support (OpenAI, Anthropic, Google, Meta, on-prem)</li>
          <li>Ultra-low latency via reverse proxy or API</li>
        </ul>

        <h2 className="sapien-subtitle">Key Benefits</h2>
        <ul className="sapien-list">
          <li>Stronger safety and compliance</li>
          <li>Protection for brand, data, and users</li>
          <li>Zero-trust verification for every interaction</li>
          <li>A unified security layer for all AI systems</li>
        </ul>

      </div>

      <Footer />
    </div>
  );
};

export default AIFirewall;
